module.exports = __webpack_public_path__ + "img/public/SiteIcons/cvvIcon.svg?7b3aa52e";